export const MANUAL_DOC_URL =
  "https://d3gcyqrqkp5kxt.cloudfront.net/Supplier-Hub/Videos/Supply_Spot_Plus_Workflow_and_Vendor_Onboarding_User_Manual+(2).docx";

export function getManualViewerEmbedUrl(docUrl = MANUAL_DOC_URL) {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(docUrl)}`;
}
